module.exports = __webpack_public_path__ + "img/1.17a8fcb4.png";